import {Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MicroSelectComponent} from "../../shared/select/micro-select.component";
import {debounceTime} from "rxjs/operators";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-access-category-select',
  templateUrl: './saAccessCategory-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: SaAccessCategorySelectComponent
    }
  ]
})
export class SaAccessCategorySelectComponent implements OnInit, OnChanges, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  allLabel:string = 'All';

  @Input()
  allSelectOption:boolean = false;

  @Input()
  allId:string;

  @Input()
  requiredLabel:string;

  @Input()
  mode:string = 'simple';

  @Output()
  categoryIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  categoryId:any;

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  sizeDynamically:boolean = false;

  @Input()
  jump:boolean = false;

  @Input()
  options:any[];

  initialCategoryId:any;

  change(e) {
    this.onChange(e);
    this.categoryIdChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  onChange = (val) => {};
  onTouched = () => {};
  touched = false;

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(val: string): void {
    this.categoryId = val;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let changed = false;
    for (let prop in changes) {
      let change = changes[prop];
      if (prop === 'categoryId') {
        changed = changed || change.currentValue !== change.previousValue;
        this.categoryId = change.currentValue;
        this.change(change.currentValue);
      }
    }
  }

  reload() {
    let params:HttpParams = new HttpParams();

    this.sel.loading = true;
    return this.http.get(`${this.env.e.url}/access/categories/all`, {params:params})
      .subscribe(data => {
        var dataOptions = data as any[];

        if (dataOptions.length && this.allSelectOption) {
          dataOptions.unshift({id:"--ALL--", name:this.allLabel})
        }

        this.options = dataOptions as any[];

        if (this.categoryId !== this.initialCategoryId) {
          this.categoryId = this.initialCategoryId;
          this.change(this.initialCategoryId);
        } else {
          this.categoryId = undefined;
          this.change(undefined);
        }

        this.sel.loading = false;
      });
  }

  ngOnInit(): void {
    this.initialCategoryId = this.categoryId;
    if (!this.options) {
      this.reload();
    }
  }
}
